import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prx-auth-forgot-password',
  templateUrl: './auth-forgot-password.component.html',
  styleUrls: ['./auth-forgot-password.component.scss'],
})
export class AuthForgotPasswordComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
